module.exports = {
  RENEWAL_SAME_CAR: 'renewal-same-car',
  RENEWAL_CAR_CHANGE: 'renewal-car-change',
  BAD_PAYER: 'bad-payer',
  MOBILITY_OPTION_PURCHASE_OR_OTHER_OPTION: 'mobility-option-purchase-or-other-option',
  NOT_RELEVANT_ERROR: 'not-relevant-error',
  NO_LONGER_NEED: 'no-longer-need',
  HIGH_PRICE: 'high-price',
  MOVE_ABROAD: 'move-abroad',
  CASE_OF_FORCE_MAJEURE: 'case-of-force-majeure',
  SWITCH_OR_REPLACEMENT_CAR_BACK_UP: 'switch-or-replacement-car-back-up',
  OTHER: 'other',
};
